/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=solid&m=free */

import {
    faAngleDown,
    faAngleRight,
    faArrowLeft,
    faBars,
    faBell,
    faBook,
    faBookOpen,
    faBullhorn,
    faBuilding,
    faCar,
    faChartArea,
    faChartBar,
    faChartPie,
    faChevronDown,
    faChevronUp,
    faCheck,
    faCircleCheck,
    faCircleExclamation,
    faCirclePlus,
    faColumns,
    faCreditCard,
    faExclamationTriangle,
    faEye,
    faFile,
    faFileInvoiceDollar,
    faFilePdf,
    faFloppyDisk,
    faFolderOpen,
    faForward,
    faGear,
    faGripLines,
    faGripVertical,
    faHandshake,
    faIdCard,
    faList,
    faPencil,
    faPlus,
    faPrint,
    faRss,
    faScrewdriverWrench,
    faSearch,
    faSliders,
    faTable,
    faTachometerAlt,
    faTags,
    faTimesCircle,
    faTrash,
    faUpload,
    faUser,
    faUserGear,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';

export const fontAwesomeSolidIcons = {
    faAngleDown,
    faAngleRight,
    faArrowLeft,
    faBars,
    faBell,
    faBook,
    faBookOpen,
    faBullhorn,
    faBuilding,
    faCar,
    faChartArea,
    faChartBar,
    faChartPie,
    faChevronDown,
    faChevronUp,
    faCheck,
    faCircleCheck,
    faCircleExclamation,
    faCirclePlus,
    faColumns,
    faCreditCard,
    faExclamationTriangle,
    faEye,
    faFile,
    faFileInvoiceDollar,
    faFilePdf,
    faFloppyDisk,
    faFolderOpen,
    faForward,
    faGear,
    faGripLines,
    faGripVertical,
    faHandshake,
    faIdCard,
    faList,
    faPencil,
    faPlus,
    faPrint,
    faRss,
    faScrewdriverWrench,
    faSearch,
    faSliders,
    faTable,
    faTachometerAlt,
    faTags,
    faTimesCircle,
    faTrash,
    faUpload,
    faUser,
    faUserGear,
    faUsers,
};
